import FlagIcon from './FlagIcon'

export {FlagIcon}
export default FlagIcon
